import styled, { css } from 'styled-components'

const Container = styled.div`
${({ theme }) => {
        return css`
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            text-align: center;
            max-width: 100vw;
            
        `;
    }}
`;

const Wave = styled.img`
${({ theme }) => {
        const { device } = theme;
        return css`
            width: 100%;
            position: absolute;
            top: 205px;
            z-index: 0;
            @media ${device.tabletM} {
                display: none;
            }
        `;
    }}
`;

const WaveVertical = styled.img`
${({ theme }) => {
        const { device } = theme;
        return css`
            display: none;
            @media ${device.tabletM} {
                display: flex;
                position: absolute;
                top: 0px;
                width: 43vw;
                height: 100vh;
            }
        `;
    }}
`;

const InfoBoxWrapper = styled.div`
${({ theme }) => {
        const { device } = theme;
        return css`
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin-top: 90px;
            @media ${device.tabletM} {
                height: 603px;
                justify-content: space-between;
            }
        `;
    }}
`;

const InfoBox = styled.div`
${({ theme }) => {
        const { device } = theme;
        return css`
            width: 350px;
            // height: 71px;
            padding: 30px;
            margin-bottom: 24px;
            position: relative;
            background: #FFFFFF;
            box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
            border-radius: 30px;
            cursor: pointer;
            @media ${device.tabletM} {
                // height: 79px;
            }
        `;
    }}
`;

const InfoBoxCircle = styled.div`
${({ theme }) => {
        return css`
            position: absolute;
            width: 90px;
            height: 90px;
            background: #fff;
            border-radius: 50%;
            top: -33px;
            right: 30px;
            z-index: 100;
            justify-content: center;
            align-items: center;
            display: flex;
        `;
    }}
`;

const MudIcon = styled.img`
${({ theme }) => {
        const { device } = theme;
        return css`
            position: absolute;
            width: 70px;
            height: 70px;
            background: #fff;
            border-radius: 50%;
            z-index: 101;
            @media ${device.tabletM} {
                width: 70px;
                height: 70px;
            }
        `;
    }}
`;

const InfoBoxTitle = styled.div`
${({ theme }) => {
        return css`
        font-family: Noto Sans KR;
        font-style: normal;
        font-weight: bold;
        font-size: 22px;
        line-height: 24px;
        text-align: start;
        color: #223F49;
        `;
    }}
`;

const InfoBoxDesc = styled.div`
${({ theme }) => {
        const { device } = theme;
        return css`
        margin-top: 15px;
        font-family: Noto Sans KR;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        color: rgba(34, 63, 73, 0.9);
        text-align: start;
        @media ${device.tabletM} {
            font-size: 14px;
            line-height: 21px;
        }
        `;
    }}
`;

const styledComponents = { Container, Wave, WaveVertical, InfoBoxWrapper, InfoBox, InfoBoxCircle, MudIcon, InfoBoxTitle, InfoBoxDesc };

export default styledComponents;